
import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, Alert, TouchableOpacity, ScrollView } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import theme from './../../lib/theme.js';
import { FontAwesome5, Ionicons, MaterialIcons, MaterialCommunityIcons } from '@expo/vector-icons';
import { apiFetch } from '../modules/api';



const Tienda = () => {

  const navigation = useNavigation();
  const [errorMsg, setErrorMsg] = useState(null);

  const showAlert = () =>

    Alert.alert(gMsg, 'Oprima Aceptar para continuar', [
      { text: "Aceptar" }
    ],
      { cancelable: true });


  useEffect(() => {
    let mounted = true;
    gPantalla = "";
    return () => mounted = false;
  }


    , []);

  function EncenderCamara(tipoFoto) {

    gFoto = "";
    gVerFoto = "";
    gMostrarFoto = "no";
    gImagen64 = "";
    gFoto1 = "";
    gFoto2 = "";
    gFoto3 = "";
    gFoto4 = "";
    gFoto5 = "";
    gFoto6 = "";
    gFoto7 = "";
    gFoto8 = "";
    gFoto9 = "";
    gFoto10 = "";
    gTipoFoto = tipoFoto;
    navigation.navigate("Fotos");


  }

  async function validarGpsEncendido() {

    let { status } = await Location.requestForegroundPermissionsAsync();

    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
      showAlert();
      navigation.navigate("Acceso");
      return;
    } else {
      let location = await Location.watchPositionAsync(
        {
          accuracy: Location.Accuracy.Balanced,
          timeInterval: 1000,
          distanceInterval: 10
        },
        (loc) => {
          gGeo = loc.coords;
        }
      );
    }
  }


  function irFotosCarrete() {
    gPantalla = "";
    gCheckbox = "";
    navigation.navigate("FotosCarrete");
  }

  async function registarSalida() {
    try {
      var altitude = gGeo.altitude
      var latitude = gGeo.latitude
      var longitude = gGeo.longitude
    } catch {

      validarGpsEncendido();

    }
    var datos = '{"usuario" : "' + gUsuario + '","operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '","latitude" : "' + latitude + '","longitude" : "' + longitude + '","altitude" : "' + altitude + '"}'


    var requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    };

    const response = await apiFetch(gApiPath + "/api/cerrarUltimaTienda", requestOptions);
    const json = await response.json();

    if (json.estatus == "bien") {

      navigation.goBack();

    } else {

      gMsg = json.mensaje;
      showAlert();

    }

  }

  const getDeterminanteDetalle = (data, opc) => {
    const text = data.split("-");
    if (opc === 1) {
      if (text.length > 0) {
        return text[0].trim();
      }
    }
    if (opc === 2) {
      if (text.length > 1) {
        return text[1].trim();
      }
    }
    return "";
  }


  return (

    <View style={styles.container}>
      <Fondo />
      <View style={{...styles.header, height: "120px"}} >
        <View
          style={{
            ...theme.cards, backgroundColor: "#fff",
            flexWrap: 'wrap', flex: 1, justifyContent: "center"
          }}>
          <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
            <MaterialCommunityIcons style={{ textAlign: 'center', marginTop: -10 }} name="store" size={50} color="#333" />
          </View>
          <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
            <Text style={{ ...theme.subTitle, fontWeight: 'bold' }} ellipsizeMode="tail" numberOfLines={2}>{gOperador.toUpperCase() + " - " + gDeterminante.toUpperCase()}</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 1)}{}</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 2)}{}</Text>
          </View>
        </View>
      </View>
      <ScrollView >
        <View style={styles.header} >
          <View style={theme.containerGrid2}>
            <TouchableOpacity style={{ ...theme.buttonCards, ...theme.buttonContentCards, backgroundColor: theme.colors.dangerLight }} onPress={() => navigation.navigate('TareasPendientes')}>
              <FontAwesome5 style={{ textAlign: 'center' }} name="tasks" size={50} color="white" />
              <Text style={theme.buttonContentText} numberOfLines={1}>{'Incidencias'}</Text>
              <Text style={{...theme.buttonContentText, marginTop: -4}}>{'pendientes'}</Text>
            </TouchableOpacity>
            {/*<TouchableOpacity  style={styles.container2} onPress={()=>navigation.navigate('FacturasListado')}>
          <ButtonGradient texto="Facturas" />
      </TouchableOpacity>*/}

            <TouchableOpacity style={{ ...theme.buttonCards, ...theme.buttonContentCards, backgroundColor: theme.colors.primaryLight }} onPress={() => navigation.navigate('DashboardTienda')}>
              <Ionicons name="stats-chart" style={{ textAlign: 'center' }} size={50} color="#333" />
              <Text style={theme.buttonContentText} numberOfLines={1}>Inventarios</Text>
            </TouchableOpacity>

          </View>
          <View style={theme.containerGrid2}>
            <TouchableOpacity style={{ ...theme.buttonCards, ...theme.buttonContentCards, backgroundColor: theme.colors.primaryLight }} onPress={() => navigation.navigate('ListadoUPCS')}>
              <MaterialIcons style={{ textAlign: 'center' }} name="local-grocery-store" size={50} color="#333" />
              <Text style={theme.buttonContentText} numberOfLines={1}>Productos</Text>
            </TouchableOpacity>
            <TouchableOpacity style={{ ...theme.buttonCards, ...theme.buttonContentCards, backgroundColor: theme.colors.primaryLight }} onPress={() => EncenderCamara("exhibidor")}>
              <MaterialCommunityIcons style={{ textAlign: 'center' }} name="library-shelves" size={50} color="#333" />
              <Text style={theme.buttonContentText} numberOfLines={1}>Fotos exhibidor</Text>
            </TouchableOpacity>
          </View>
          <View style={theme.containerGrid2}>
            <TouchableOpacity style={{ ...theme.buttonCards, ...theme.buttonContentCards, backgroundColor: theme.colors.primaryLight }} onPress={() => EncenderCamara("bodega")}>
              <MaterialCommunityIcons style={{ textAlign: 'center' }} name="warehouse" size={50} color="#333" />
              <Text style={theme.buttonContentText} numberOfLines={1}>Fotos bodega</Text>
            </TouchableOpacity>
            <TouchableOpacity style={{ ...theme.buttonCards, ...theme.buttonContentCards, backgroundColor: theme.colors.success }} onPress={() => registarSalida()}>
              <MaterialCommunityIcons style={{ textAlign: 'center' }} name="store-check" size={50} color="white" />
              <Text style={{ ...theme.buttonContentText }} numberOfLines={1}>Cerrar tienda</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView >
    </View>

  );
}

export default Tienda

const styles = StyleSheet.create({
  header: {
    width: '100%',

  },

  container: {
    backgroundColor: '#f1f1f1',
    alignItems: 'center',
  },

  titulo1: {
    fontSize: 50,
    color: "white",
    fontWeight: 'bold',
    marginTop: 50,
  },

  titulo2: {
    fontSize: 35,
    color: "white",
    fontWeight: 'bold'
  },

  titulo3: {
    fontSize: 50,
    color: "white",
    fontWeight: 'bold'
  },

  titleContainer: {
    padding: 10,
  },

  subTitle: {
    fontSize: 20,
    color: 'black',
  },

  subTitle2: {
    fontSize: 25,
    color: 'black',
    marginTop: 10,
    fontWeight: 'bold',

  }, container2: {

    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    marginLeft: 30,
    width: '80%',
    height: 50
  },
  scrollView: {
    marginHorizontal: 100,
    width: '90%',
    height: '100%'
  },


});


